import AsyncStorage from '@react-native-async-storage/async-storage';

export const getData = async item => {
  try {
    return await AsyncStorage.getItem(item);
  } catch (error) {
    console.error('Failed to fetch the data from storage', error);
  }
};

export const setData = async (key, value) => {
  try {
    await AsyncStorage.setItem(key, value);
    console.log('Data successfully saved');
  } catch (error) {
    console.error('Failed to save the data to the storage', error);
  }
};

/**
 * Clears all data from AsyncStorage.
 */
export const clearAsyncStorage = async () => {
  try {
    await AsyncStorage.clear();
    console.log('AsyncStorage cleared successfully.');
  } catch (error) {
    console.error('Error clearing AsyncStorage:', error);
  }
};
